class WishlistIcon extends HTMLElement {
  static eventsBound = false;

  connectedCallback() {
    WishlistIcon.guardIdentity(this.dataset.customerId || '');
    this.refresh();
    WishlistIcon.bindEvents();
    document.addEventListener('bonobos:wishlist:changed', this.onWishlistChanged);
    document.addEventListener('bonobos:saved-items-changed', this.onWishlistChanged);
    document.addEventListener('click', this.onAnyClick, true);
    window.addEventListener('pageshow', this.onPageShow);
  }

  disconnectedCallback() {
    document.removeEventListener('bonobos:wishlist:changed', this.onWishlistChanged);
    document.removeEventListener('bonobos:saved-items-changed', this.onWishlistChanged);
    document.removeEventListener('click', this.onAnyClick, true);
    window.removeEventListener('pageshow', this.onPageShow);
  }

  onAnyClick = (event) => {
    if (event.target.closest && event.target.closest('[data-wishlist-toggle]')) {
      setTimeout(() => this.refresh(), 600);
      setTimeout(() => this.refresh(), 2000);
    }
  };

  onWishlistChanged = () => {
    this.refresh();
  };

  onPageShow = (event) => {
    if (event.persisted) this.refresh();
  };

  refresh() {
    if (window.__bonobosWishlistIdentityChanged) {
      this.dataset.hasItems = 'false';
      return;
    }
    WishlistIcon.withSwym((swat) => {
      if (typeof swat.fetch !== 'function') return;
      swat.fetch((items) => {
        if (window.__bonobosWishlistIdentityChanged) return;
        const hasItems = Array.isArray(items) && items.length > 0;
        this.dataset.hasItems = hasItems ? 'true' : 'false';
      });
    });
  }

  static withSwym(cb) {
    if (window._swat) {
      cb(window._swat);
      return;
    }
    (window.SwymCallbacks = window.SwymCallbacks || []).push(cb);
  }

  // Locally cached "pending" saves are per-shopper; carrying them across a
  // login/logout boundary makes the icon and the saved-items page disagree
  // with Swym's list for the new identity. Swym itself also serves the
  // previous identity's cached list for a beat after the boundary, so the
  // change is published on window and positive answers are distrusted for
  // the rest of this pageview (an explicit add re-enables them).
  static guardIdentity(customerId) {
    if (window.__bonobosWishlistIdentityChanged !== undefined) return;
    const key = 'bonobos:wishlist-identity';
    let changed = false;
    try {
      const previous = window.localStorage.getItem(key) || '';
      const current = String(customerId || '');
      if (previous !== current) {
        changed = true;
        window.localStorage.removeItem('bonobos:pending-saved-items');
        try { window.sessionStorage.removeItem('bonobos:pending-saved-items'); } catch (_e) { /* noop */ }
        window.localStorage.setItem(key, current);
      }
    } catch (_e) {
      // Storage unavailable — Swym remains the source of truth.
    }
    window.__bonobosWishlistIdentityChanged = changed;
  }

  static bindEvents() {
    if (WishlistIcon.eventsBound) return;
    WishlistIcon.eventsBound = true;

    WishlistIcon.withSwym((swat) => {
      if (!swat.evtLayer || !swat.JSEvents) return;

      const dispatch = () => {
        document.dispatchEvent(new CustomEvent('bonobos:wishlist:changed'));
      };

      swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, () => {
        window.__bonobosWishlistIdentityChanged = false;
        dispatch();
      });
      swat.evtLayer.addEventListener(swat.JSEvents.removedFromWishlist, dispatch);
    });
  }
}

if (!customElements.get('wishlist-icon')) {
  customElements.define('wishlist-icon', WishlistIcon);
}
